import React from "react";

const firstIcon = `${EASYCOMMERCE.assets}admin/img/icons/ArrowLeft.png`;
const backIcon = `${EASYCOMMERCE.assets}admin/img/icons/Back.png`;

export default function Previous({ baseSlug = "products", current = 1 }) {
    return (
        <>
            {current > 1 ? (
                <>
                    <a
                        href={`#/${baseSlug}`}
                        className="flex text-ec-body font-inter text-sm leading-5 items-center gap-2 py-2 px-3 border border-ec-border rounded-[4px] hover:border-ec-primary hover:text-ec-body active:text-ec-body active:shadow-none focus:text-ec-body focus:shadow-none"
                    >
                        <div>
                            <img
                                src={firstIcon}
                                width={10}
                                height={8}
                                alt="arrow"
                                className="pointer-events-none"
                            />
                        </div>
                        <span>First</span>
                    </a>
                    <a
                        href={`#/${baseSlug}/page/${parseInt(current) - 1}`}
                        className="flex text-ec-body font-inter text-sm leading-5 items-center gap-2 py-2 px-3 border border-ec-border rounded-[4px] hover:border-ec-primary hover:text-ec-body active:text-ec-body active:shadow-none focus:text-ec-body focus:shadow-none"
                    >
                        <div>
                            <img
                                src={backIcon}
                                width={8}
                                height={5}
                                alt="arrow"
                                className="pointer-events-none"
                            />
                        </div>
                        <span>Back</span>
                    </a>
                </>
            ) : (
                <>
                    <div className="flex text-ec-body font-inter text-sm leading-5 items-center gap-2 py-2 px-3 border border-ec-border rounded-[4px] hover:text-ec-body cursor-not-allowed active:text-ec-body active:shadow-none focus:text-ec-body focus:shadow-none">
                        <div>
                            <img
                                src={firstIcon}
                                width={10}
                                height={8}
                                alt="arrow"
                                className="pointer-events-none"
                            />
                        </div>
                        <span>First</span>
                    </div>
                    <div className="flex text-ec-body font-inter text-sm leading-5 items-center gap-2 py-2 px-3 border border-ec-border rounded-[4px] hover:text-ec-body cursor-not-allowed active:text-ec-body active:shadow-none focus:text-ec-body focus:shadow-none">
                        <div>
                            <img
                                src={backIcon}
                                width={8}
                                height={5}
                                alt="arrow"
                                className="pointer-events-none"
                            />
                        </div>
                        <span>Back</span>
                    </div>
                </>
            )}
        </>
    );
}
